'use client'

import { Button, Result } from 'antd'
import { useRouter } from 'next/navigation'

export default function NotFound() {
  const router = useRouter()

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: '20px',
      }}
    >
      <Result
        status='404'
        title='404'
        subTitle='Sorry, the page you visited does not exist.'
        extra={[
          <Button type='primary' key='back' onClick={() => router.back()}>
            Go Back
          </Button>,
        ]}
      />
    </div>
  )
}
